import { useEffect, useRef, useState } from 'react';

/**
 * Largeur réelle du conteneur (ResizeObserver), pas du viewport.
 *
 * Le plugin est rendu dans le gabarit du thème WordPress de chaque site : un
 * thème peut limiter le contenu à 650 px sur un écran de 1366 px. Décider la
 * mise en page sur la largeur d'écran (breakpoints Chakra) y affichait deux
 * colonnes dans un espace qui n'en tient qu'une, et le formulaire s'écrasait.
 * Retourne 0 tant que rien n'est mesuré.
 */
export function useContainerWidth<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width ?? 0;
      setWidth((prev) => (Math.abs(prev - w) < 1 ? prev : w));
    });
    observer.observe(el);
    setWidth(el.getBoundingClientRect().width);
    return () => observer.disconnect();
  }, []);

  return [ref, width] as const;
}
